import React, {
    Component
} from 'react'

// import csvtojson from 'csvtojson';

import assert from 'assert';
import parse from 'csv-parse';

export const readFileToText = async blob => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e=>{
            resolve(e.target.result)
        };
        reader.onerror = e=>{
            reject(new Error('Error reading ' + csv.name + ' as a CSV file.'))
        };
        reader.readAsText(blob);
    });
}

export const parseCsv = async csv => {
    if (!csv instanceof Blob) {
        throw new TypeError('Must be a File or Blob')
    }

    const text = await readFileToText(csv);

    const parser = parse(text, {
        columns: true,
        skip_empty_lines: true
    });

    let record, records = [];
    parser.on('readable', ()=>{
        while (record = parser.read()) {
            records.push(record);
        }
    });

    return new Promise((resolve, reject) => {
        parser.on('end', ()=>{
            if(records.length === 0){
                reject(new Error(`The CSV is empty.`));
            }
            resolve(records);
        })
        parser.on('error', (err)=>{
            reject(err);
        })
    });
}